<script setup>
import { ShieldAlert, ArrowRight } from '@lucide/vue';
import { Link, router } from '@inertiajs/vue3';

function exitGuestMode() {
  router.post(route('guest.logout'));
}
</script>

<template>
  <div class="bg-gradient-to-r from-amber-600 via-amber-700 to-orange-700 text-white text-xs py-2.5 px-4 shadow-md select-none">
    <div class="max-w-7xl mx-auto flex flex-wrap items-center justify-between gap-3">
      <div class="flex items-center gap-2">
        <ShieldAlert class="w-4 h-4 shrink-0 text-amber-200" />
        <span>
          <strong>Mode Tamu Aktif:</strong> Anda sedang menjelajah sebagai tamu. Transaksi, dompet, dan perubahan akun dinonaktifkan.
        </span>
      </div>

      <div class="flex items-center gap-3">
        <a :href="route('auth.google')" class="underline hover:text-amber-100 transition font-medium">Masuk Google</a>
        <span class="opacity-50">|</span>
        <Link :href="route('login')" class="underline hover:text-amber-100 transition font-medium">Masuk WhatsApp</Link>
        <span class="opacity-50">|</span>
        <button
          @click="exitGuestMode"
          type="button"
          class="bg-black/30 hover:bg-black/50 px-2.5 py-1 rounded-lg font-semibold transition text-[11px] uppercase tracking-wider border border-white/20"
        >
          Keluar Mode Tamu
        </button>
      </div>
    </div>
  </div>
</template>
